module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/related/ko/4-6d533837d1efbfa78ac98eb291b3890b.jpg";